import { useEffect } from 'preact/hooks';

export function usePageTitle(title: string | undefined, addSuffix = true) {
  const pageTitle = title
    ? title + (addSuffix ? ' | Adblock Podcast' : '')
    : 'Adblock Podcast';

  // SSR
  if (typeof window === 'undefined') {
    globalThis.pageTitle = pageTitle;
  }

  // Client
  useEffect(() => {
    document.title = pageTitle;
  }, [pageTitle]);
}
